/**
 * 장기선결제 내역 · 환불 모달 ($j.Ui.JBModal.target 결합).
 * 레거시 public/skw_3311.php 대체. 회비결제방식 창(FeeWay [내역 · 환불])·선결제 추가(PrepayForm.openLog) 가 연다.
 * 제목 옆 '카드결제하기'(테스트 계정 대리로그인)는 개발모드(G5.isDebug)에서만 붙인다.
 *
 * 사용법:
 *   $j.Ui.JBModal.target('prepay-modal', {
 *       target: '$j.F.Admin.Member.PrepayLog',
 *       data:   { mbNo: 123 },
 *       title:  '회비 내역',
 *       width:  '700px',
 *   });
 */
import Util from '../../../Common/Util';

/** 상단 '카드결제하기' 버튼이 여는 프록시 로그인 대상 — 카드결제(페이앳) 테스트계정
 *  '불러6(페이앳)'(g5_members.num=9042). 지금 보고 있는 회원과 무관하게 항상 이 번호로
 *  앱 카드결제 화면을 확인한다. */
const CARD_PAY_TEST_MB_NO = 9042;

export default class PrepayLog {
    constructor() { this.$wrap = null; }
    destroy() {}

    init() {
        this.mbNo = this.data.mbNo;
        $(`#${this.id}`).html('<div style="padding:20px;text-align:center;color:#888">로딩중...</div>');
        this.bindCardPayButton();
        this.load();
    }

    /** 모달 제목("회비 내역") 옆에 '카드결제하기' 버튼을 붙인다. body(`#${this.id}`)는
     *  load()·refund() 후 통째로 다시 그려지므로, 거기 넣으면 매번 다시 붙여야 한다 —
     *  제목 영역은 다시 그려지지 않으니 여기서 한 번만 붙인다. */
    bindCardPayButton() {
        if (typeof G5 === 'undefined' || !G5.isDebug) return;   // 테스트 계정(9042)으로 여는 개발용 — 운영 화면에는 두지 않는다
        const $title = $(`#${this.id}`).closest('.ui-modal').find('.ui-modal__title');
        if (!$title.length || $title.find('#prepayCardPay').length) return;
        $title.append(' <button type="button" class="me-btn" id="prepayCardPay" style="margin-left:8px;vertical-align:middle">카드결제하기</button>');
        $title.find('#prepayCardPay').on('click', () => this.openCardPay());
    }

    load() {
        const self = this;
        $.ajax({
            type: 'get',
            url: '/adm/ajax/member/prepay/log',
            data: { mb_no: self.mbNo },
            dataType: 'json',
            success(data) {
                self.state = data;
                self.render();
                self.bind();
            },
            error() {
                $(`#${self.id}`).html('<div style="padding:20px;text-align:center;color:var(--adm-kw-red, red)">데이터를 불러오지 못했습니다.</div>');
            },
        });
    }

    render() {
        const s = this.state;
        const today = s.today;
        const won = (n) => `${Util.formatNumber(n)}원`;
        const rows = (s.list || []).map((r) => {
            const expired = !r.cancel_date && r.end_date < today;
            let manage;
            if (r.cancel_date) manage = '<span class="pl-bad">환불됨</span>';
            else if (expired) manage = '<span class="pl-mute">만료</span>';
            else manage = `<button type="button" class="me-btn prepay-refund-btn" data-num="${r.num}">환불</button>`;
            return `<tr${r.is_cur == 1 ? ' class="is-cur"' : ''}>
                <td class="pl-c">${this._esc(r.start_date)}</td>
                <td class="pl-c">${this._esc(r.end_date)}</td>
                <td class="pl-c">${this._esc(r.period)}개월</td>
                <td class="pl-r">${r.price ? won(r.price) : ''}</td>
                <td class="pl-c">${expired ? '-' : `${Util.formatNumber(r.used_days)}일 / ${Util.formatNumber(r.total_days)}일`}</td>
                <td class="pl-r">${expired ? '-' : (r.cancel_date ? `<span class="pl-bad">${won(r.refund_done ?? 0)}</span>` : won(r.refund_price))}</td>
                <td class="pl-c">${manage}</td>
                <td class="pl-c">${this._esc(r.datetime)}</td>
            </tr>`;
        }).join('');

        // 관리자 토큰만 쓴다 — 회비 내역(FeeHistory) · 회비결제방식(FeeWay) 창과 같은 표 모양. 지금 기간 줄은 옅게 칠한다
        $(`#${this.id}`).html(`<style>
.pl-t{width:100%;border-collapse:collapse;font-size:12.5px}
.pl-t th{padding:5px 8px;background:var(--adm-surface-soft);border:1px solid var(--adm-border);font-weight:600;white-space:nowrap}
.pl-t td{padding:5px 8px;border:1px solid var(--adm-border);vertical-align:middle}
.pl-t tr.is-cur td{background:var(--adm-row-hover, var(--adm-surface-soft))}
.pl-c{text-align:center;white-space:nowrap}
.pl-r{text-align:right;white-space:nowrap}
.pl-mute{color:var(--adm-text-muted)}
.pl-bad{color:var(--adm-kw-red, red)}
.pl-note{margin-top:8px;font-size:11.5px;color:var(--adm-text-muted)}
</style>
        <table class="pl-t"><thead><tr><th>시작</th><th>종료</th><th>기간</th><th>금액</th><th>경과일(사용일)</th><th>환불금액</th><th>관리</th><th>처리일시</th></tr></thead>
            <tbody>${rows || '<tr><td colspan="8" class="pl-c pl-mute" style="padding:20px">장기선결제 내역이 없습니다.</td></tr>'}</tbody></table>
        <div class="pl-note">지금 기간에 든 줄은 바탕색이 다릅니다. 환불금액 = 결제금액 − 환불수수료 10% − (경과일 ÷ 총일수 × 결제금액). 경과일은 시작일부터 오늘까지이고(환불할 때 사용 종료일을 바꿀 수 있습니다), 90% 이상 쓰면 0원입니다. 환불하면 그 선결제는 끝납니다.</div>`);
    }

    bind() {
        const self = this;
        $(`#${this.id}`).find('.prepay-refund-btn').off('click').on('click', function () {
            const num = parseInt($(this).data('num'), 10);
            self.refund((self.state.list || []).find((r) => parseInt(r.num, 10) === num));
        });
    }

    /** 환불 창 — 실제 사용 종료일(기본 오늘)을 바꾸면 서버가 금액을 다시 계산한다. 시작 전인 건은 전액이라 날짜를 묻지 않는다 */
    async refund(r) {
        const today = this.state.today;
        const inputId = 'prepayUsedDate';
        const usedText = (used, total) => `${Util.formatNumber(used)}일 / ${Util.formatNumber(total)}일`;
        const defaultDate = r.end_date < today ? r.end_date : today;

        let usedDate = '';
        let error = '';
        let pending = false;
        let seq = 0;    // 날짜를 빠르게 바꿨을 때 늦게 온 옛 응답을 버린다

        const recalc = () => {
            const $root = $(`#${inputId}`).closest('.ui-dlg-panel');
            const date = $(`#${inputId}`).val();
            const mine = ++seq;
            if (!date) { pending = false; error = '사용 종료일을 넣어 주세요.'; return; }
            pending = true;
            error = '';
            $.getJSON('/adm/ajax/member/prepay/quote', { num: r.num, mb_no: this.mbNo, used_date: date })
                .done((q) => {
                    if (mine !== seq) return;
                    pending = false;
                    if (!q.result) { error = q.message; return; }
                    $root.find('.ui-dlg__row dd').eq(1).text(usedText(q.usedDays, q.totalDays));
                    $root.find('.ui-dlg__row dd').eq(2).text(`${Util.formatNumber(q.refund)}원`);
                })
                .fail(() => { if (mine === seq) { pending = false; error = '금액을 계산하지 못했습니다.'; } });
        };

        const ok = await $j.Ui.Dialog.open({
            title: '환불할까요?',
            html: r.start_date > today ? '' : `<label class="ui-dlg-inlabel" for="${inputId}">실제 사용 종료일</label>
                <input id="${inputId}" class="ui-dlg-input" type="text" readonly value="${defaultDate}">`,
            rows: [
                { k: '결제금액', v: `${Util.formatNumber(r.price)}원` },
                { k: '경과일(사용일)', v: usedText(r.used_days, r.total_days) },
                { k: '환불금액', v: `${Util.formatNumber(r.refund_price)}원`, tone: 'danger' },
            ],
            validate: () => (pending ? '금액을 계산하는 중입니다.' : error),
            confirm: '환불',
            cancel: '취소',
            // 날짜칸에 자동 포커스가 가면 엔터 한 번에 환불이 나가므로 뺀다
            onOpen: () => {
                const $input = $(`#${inputId}`).trigger('blur');
                if (!$input.length) return;
                $input.mobiscroll().datepicker({
                    controls: ['calendar'],
                    dateFormat: 'YYYY-MM-DD',
                    locale: mobiscroll.localeKo,
                    buttons: [],
                    min: r.start_date,
                    max: r.end_date,
                });
                $input.on('change', recalc);
            },
            onConfirm: () => { usedDate = $(`#${inputId}`).val() || ''; },
        });
        if (!ok) return;

        const self = this;
        $.ajax({
            type: 'POST',
            url: '/adm/ajax/member/prepay/refund',
            data: { num: r.num, mb_no: self.mbNo, used_date: usedDate },
            dataType: 'json',
            success(data) {
                if (data.result == 1) {
                    $j.F.Admin.Util.tsalert('success', '장기선결제건이 해지되었습니다.');
                } else {
                    $j.F.Admin.Util.tsalert('error', data.message || '실패하였습니다.');
                }
                self.load();
            },
        });
    }

    /** 앱 카드결제 화면(/m/card)을 고정 테스트계정(CARD_PAY_TEST_MB_NO)으로 프록시 로그인해
     *  새 창으로 연다 — 지금 보고 있는 회원과는 무관하다. `Util.userMobile` 과 같은 규격
     *  (500x800, 툴바·메뉴바 없는 팝업)을 그대로 써서 앱 화면 크기 그대로·테두리 없이 뜬다. */
    openCardPay() {
        const url = '/m/login/proxy?work_num=' + CARD_PAY_TEST_MB_NO
                  + '&returnurl=' + encodeURIComponent('/m/card');
        $j.F.Admin.Util.userMobile(url);
    }

    _esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
}
